import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CountUp } from './CountUp';
import { riseItem, staggerContainer, viewportOnce } from '../../utils/motion';
const stats = [{
  label: 'Chefs listed',
  node: <CountUp to={247} data-id="element-588" data-mp="3aqbeo6clj3lp" />,
  detail: 'across 41 Bangkok districts'
}, {
  label: 'Median quote turnaround',
  node: <CountUp to={38} suffix=" min" data-id="element-589" data-mp="36p99l8vzzxbt" />,
  detail: 'from request to itemised price'
}, {
  label: 'Dinners cooked',
  node: <CountUp to={11400} data-id="element-590" data-mp="31s95h3ipl4nc" />,
  detail: 'since we opened in 2023'
}, {
  label: 'Guests who book again',
  node: <CountUp to={38} suffix="%" data-id="element-591" data-mp="2wqju1mrkqoyq" />,
  detail: 'within six months'
}];
export function ProofStrip() {
  const reduce = useReducedMotion();
  return <section aria-label="Pan &amp; Apron in numbers" className="border-b border-hairline bg-canvas" data-id="element-592" data-mp="2nroli41252s9">
      <motion.dl variants={staggerContainer(0.06)} initial="hidden" whileInView="show" viewport={viewportOnce} className="mx-auto grid max-w-shell gap-x-8 gap-y-8 px-5 py-12 sm:grid-cols-2 lg:grid-cols-4 lg:px-8" data-id="element-593" data-mp="q1x0vldyebgf">
        {stats.map(stat => <motion.div key={stat.label} variants={riseItem(reduce, 16)} data-id="element-594" data-mp="15irzd8xl53a7">
            <dt className="text-[12px] font-semibold uppercase tracking-[0.05em] text-ink-3" data-id="element-595" data-mp="15fw2lnxh4knc">{stat.label}</dt>
            <dd className="mt-1.5 font-display text-3xl font-semibold tracking-[-0.02em] text-ink" data-id="element-596" data-mp="vk2mxvogkb1c">{stat.node}</dd>
            <dd className="mt-1 text-[13px] text-ink-2" data-id="element-597" data-mp="1j957bbah8hzj">{stat.detail}</dd>
          </motion.div>)}
      </motion.dl>
    </section>;
}